import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { 
  FaPhone, 
  FaEnvelope, 
  FaWhatsapp, 
  FaMapMarkerAlt,
  FaFacebook,
  FaTwitter,
  FaLinkedin,
  FaInstagram,
  FaArrowRight,
  FaClock,
  FaShieldAlt
} from 'react-icons/fa';

const NewFooter = () => {
  const currentYear = new Date().getFullYear();

  const handleContactClick = (type) => {
    switch (type) {
      case 'phone':
        window.open('tel:+97444170859', '_self');
        break;
      case 'email':
        window.open('mailto:abrajaldhafna2014@gmail.com', '_self');
        break;
      case 'whatsapp':
        window.open('https://wa.me/97455994434', '_blank');
        break;
      default:
        break;
    }
  };

  const quickLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
    { path: '/services', label: 'Services' },
    { path: '/projects', label: 'Projects' },
    { path: '/contact', label: 'Contact' }
  ];

  // Design Tokens
  const DARK_SLATE = "#0f172a";
  const GOLD = "#fbbf24";
  const TEXT_GRAY = "#94a3b8";

  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        {/* --- MAIN GRID --- */}
        <div style={styles.footerGrid}>
          
          {/* Section 1: Brand & About */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            style={styles.section}
          >
            <div style={styles.logoWrapper}>
              {/* Replace with your actual logo path or keep as placeholder */}
              <div style={styles.placeholderLogo}>
                ABRAJ <span style={{ color: GOLD }}>AL DHAFNA</span>
              </div>
            </div>
            <p style={styles.description}>
              Leading provider of skilled manpower in Qatar. We specialize in 
              rapid mobilization of experienced tradesmen for construction 
              and MEP projects.
            </p>
            <div style={styles.socialWrapper}>
              {[FaFacebook, FaTwitter, FaLinkedin, FaInstagram].map((Icon, i) => (
                <motion.a 
                  key={i} 
                  href="#" 
                  whileHover={{ y: -3, color: GOLD }} 
                  style={styles.socialIcon}
                >
                  <Icon size={20} />
                </motion.a>
              ))}
            </div>
          </motion.div>

          {/* Section 2: Quick Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            style={styles.section}
          >
            <h4 style={styles.title}>Quick Links</h4>
            <ul style={styles.linkList}>
              {quickLinks.map((link) => (
                <li key={link.path} style={styles.listItem}>
                  <FaArrowRight size={10} color={GOLD} />
                  <Link to={link.path} style={styles.link}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Section 3: Contact Details */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            style={styles.section}
          >
            <h4 style={styles.title}>Contact Us</h4>
            <div style={styles.contactItem} onClick={() => handleContactClick('phone')}>
              <FaPhone color={GOLD} />
              <span style={styles.contactText}>+974 4417 0859</span>
            </div>
            <div style={styles.contactItem} onClick={() => handleContactClick('whatsapp')}>
              <FaWhatsapp color="#25D366" />
              <span style={styles.contactText}>+974 5599 4434</span>
            </div>
            <div style={styles.contactItem} onClick={() => handleContactClick('email')}>
              <FaEnvelope color={GOLD} />
              <span style={styles.contactText}>abrajaldhafna2014@gmail.com</span>
            </div>
            <div style={styles.contactItem}>
              <FaMapMarkerAlt color={GOLD} />
              <span style={styles.contactText}>Doha, Qatar</span>
            </div>
          </motion.div>

          {/* Section 4: Accreditations */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
            style={styles.section}
          >
            <h4 style={styles.title}>Our Standards</h4>
            <div style={styles.badge}>
              <FaClock color={GOLD} />
              <span>24/7 Support</span>
            </div>
            <div style={styles.badge}>
              <FaShieldAlt color={GOLD} />
              <span>ISO Certified 9001</span>
            </div>
          </motion.div>

        </div>

        {/* --- BOTTOM BAR --- */}
        <div style={styles.bottomBar}>
          <p style={styles.copyright}>
            © {currentYear} Abraj Al Dhafna Trading & Contracting WLL.
          </p>
          <div style={styles.bottomLinks}>
            <Link to="/privacy" style={styles.footerBottomLink}>Privacy Policy</Link>
            <Link to="/terms" style={styles.footerBottomLink}>Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

// --- RESPONSIVE STYLES ---
const styles = {
  footer: {
    background: '#0f172a',
    color: '#ffffff',
    padding: '80px 20px 20px',
    borderTop: '4px solid #3b82f6',
  },
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
  },
  footerGrid: {
    display: 'grid',
    // Mobile: 1 col | Tablet: 2 cols | Desktop: 4 cols
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '40px',
    marginBottom: '60px',
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  logoWrapper: {
    marginBottom: '10px',
  },
  placeholderLogo: {
    fontSize: '24px',
    fontWeight: '900',
    letterSpacing: '1px',
  },
  description: {
    color: '#94a3b8',
    lineHeight: '1.6',
    fontSize: '14px',
  },
  title: {
    fontSize: '18px',
    fontWeight: '700',
    marginBottom: '10px',
    position: 'relative',
    paddingBottom: '10px',
    borderBottom: '2px solid rgba(251, 191, 36, 0.3)',
    width: 'fit-content',
  },
  linkList: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  link: {
    color: '#94a3b8',
    textDecoration: 'none',
    fontSize: '14px',
    transition: 'color 0.2s',
  },
  contactItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    fontSize: '14px',
    color: '#94a3b8',
    cursor: 'pointer',
  },
  contactText: {
    fontSize: '14px',
    wordBreak: 'break-all',
  },
  socialWrapper: {
    display: 'flex',
    gap: '15px',
    marginTop: '10px',
  },
  socialIcon: {
    color: '#94a3b8',
    transition: 'all 0.3s ease',
  },
  badge: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    background: 'rgba(255,255,255,0.05)',
    padding: '12px',
    borderRadius: '8px',
    fontSize: '13px',
    color: '#cbd5e1',
  },
  bottomBar: {
    paddingTop: '30px',
    borderTop: '1px solid rgba(255,255,255,0.1)',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '20px',
  },
  copyright: {
    fontSize: '13px',
    color: '#64748b',
  },
  bottomLinks: {
    display: 'flex',
    gap: '20px',
  },
  footerBottomLink: {
    color: '#64748b',
    textDecoration: 'none',
    fontSize: '13px',
  }
};

export default NewFooter;